import Router from "next/router";
import { callFlutterEventHandler, isWebView } from "@utils/commonUtils";

interface OpenDeeplinkArgs {
  deeplink?: string;
  path?: string;
  queryParams?: Record<string, string>;
  useOrderIdFromRouter?: boolean;
}

const buildDeeplink = ({
  path,
  queryParams = {},
  useOrderIdFromRouter = false,
}: Omit<OpenDeeplinkArgs, "deeplink">) => {
  if (!path) return null;

  const params = new URLSearchParams();

  Object.entries(queryParams).forEach(([key, value]) => {
    if (value != null && value !== "") {
      params.set(key, String(value));
    }
  });

  if (useOrderIdFromRouter) {
    const orderId = Router.query?.order_id;
    if (orderId && !params.has("order_id")) {
      params.set(
        "order_id",
        String(Array.isArray(orderId) ? orderId[0] : orderId)
      );
    }
  }

  const qs = params.toString();
  return `acko.com://${path}${qs ? `?${qs}` : ""}`;
};

export const openDeeplink = (args: OpenDeeplinkArgs = {}) => {
  const deeplink =
    args.deeplink ||
    buildDeeplink({
      path: args.path,
      queryParams: args.queryParams,
      useOrderIdFromRouter: args.useOrderIdFromRouter,
    });

  if (!deeplink) {
    console.error("openDeeplink: `deeplink` or `path` is required");
    return;
  }

  if (typeof window === "undefined") return;

  if (isWebView()) {
    callFlutterEventHandler(
      JSON.stringify({
        action: "open_deeplink",
        action_value: { deeplink },
      })
    );
    return;
  }

  console.warn("openDeeplink: not in app webview, cannot open:", deeplink);
};

export default openDeeplink;